/* loaded by smart-asset */
export default require("./almonds~diBVNtXO.png")